var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Range } from "react-range";
// components
import { Track, Thumb, TrackWrapper } from "./input.styles";
import { Layer } from "./layer.styles";
import { Wrapper } from "./wrapper.styles";
import { Steps } from "./steps.styles";
import { Label } from "./label.styles";
export function Slider(_a) {
    var { min, max, step, onChange, values, disabled, rtl, labelLeft, labelRight } = _a, restProps = __rest(_a, ["min", "max", "step", "onChange", "values", "disabled", "rtl", "labelLeft", "labelRight"]);
    const [focused, setFocused] = useState(false);
    return (_jsxs(Wrapper, Object.assign({}, restProps, { children: [_jsx(Label, { children: labelLeft }), _jsx(Range, Object.assign({ disabled: disabled, values: values, step: step, min: min, rtl: rtl, max: max, onChange: onChange }, (step
                ? {
                    renderMark: ({ props, index }) => index * step !== max && (_jsx(Steps, Object.assign({}, props, { values: values, index: index, step: step, disabled: disabled }))),
                }
                : {}), { renderTrack: ({ props, children }) => (_jsx(TrackWrapper, Object.assign({ style: Object.assign({}, props.style) }, { children: _jsx(Track, Object.assign({ values: values, min: min, max: max, ref: props.ref, disabled: disabled, multiple: values.length > 1 }, { children: children })) }))), renderThumb: ({ index, props }) => (_jsx(Thumb, Object.assign({}, props, { onKeyDown: (e) => props.onKeyDown(e), onMouseDown: () => setFocused(false), onKeyUp: () => setFocused(true), onBlur: () => setFocused(false), disabled: disabled, focused: focused }, { children: _jsx(Layer, Object.assign({ "data-label": index, style: Object.assign({}, props.style) }, { children: values[index] })) }))) })), _jsx(Label, { children: labelRight })] })));
}
